import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { FULL_TESTIMONIALS } from '../../data/content';
function getInitials(name: string) {
  return name.split(' ').map(part => part.charAt(0)).join('').slice(0, 2);
}
export function Testimonials() {
  return <section className="w-full bg-cream-deep px-5 py-14 sm:py-20" data-id="element-237" data-mp="3r93hz1pj4eyr">
      <div className="mx-auto max-w-5xl" data-id="element-238" data-mp="1zeuhwi9cvm">
        <Reveal className="text-center" data-id="element-239" data-mp="y4kfnbcuey">
          <SectionBadge data-id="element-240" data-mp="429vqplu5np9">Testimonios</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-3xl leading-tight text-cocoa sm:text-5xl" data-id="element-241" data-mp="40zu5qfrxxdv">
            Lo que dicen quienes <span className="italic text-terra" data-id="element-242" data-mp="e0z1xl4ddjpo">ya empezaron</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-243" data-mp="2at90mmemffc6">
          {FULL_TESTIMONIALS.map((testimonial, index) => <Reveal key={testimonial.name} delay={index % 2 * 60} as="article" data-id="element-244" data-mp="2fsc2xz37v7gg" data-mpi={index}>
              <div className="flex h-full flex-col rounded-2xl bg-cream-card p-5 shadow-[0_1px_0_rgba(58,41,32,0.06)] sm:p-7" data-id="element-245" data-mp="2fu6tbsx9brrx">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-246" data-mp="1ntat5boqt65o">
                  {Array.from({
                length: 5
              }).map((_, starIndex) => <StarIcon key={starIndex} className="h-4 w-4 fill-terra text-terra" aria-hidden="true" data-id="element-247" data-mp="1iuzmtaxnpds7" data-mpi={starIndex} />)}
                </span>

                <p className="mt-4 flex-1 font-display text-xl leading-snug text-cocoa sm:text-[22px]" data-id="element-248" data-mp="2bj55ls55gspe">
                  “{testimonial.quote}”
                </p>

                <div className="mt-6 flex items-center gap-3 border-t border-sand-line pt-4" data-id="element-249" data-mp="26l3png30t9i5">
                  <span aria-hidden="true" className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-olive text-xs font-extrabold text-cream" data-id="element-250" data-mp="22gvwn6pj57e4">
                    {getInitials(testimonial.name)}
                  </span>
                  <span data-id="element-251" data-mp="m3xml6cd08sn">
                    <span className="block text-sm font-bold text-cocoa" data-id="element-252" data-mp="m3fk3rz3syca">{testimonial.name}</span>
                    <span className="block text-xs text-cocoa-dim" data-id="element-253" data-mp="nmnvs9uinm8n">{testimonial.city}</span>
                  </span>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}